// extracted by mini-css-extract-plugin
export default {"container":"GameEditor_container__l2sZ4"};